import styled from 'styled-components';
import {dFlex, dFlexCenter, mobileMedia} from '../../../../globalVariables/GlobalVariables';
import {row as shellRow, timeLabel as shellTimeLabel} from '../timeRowShell/TimeRowShell.css';

export const row = styled(shellRow)`
    ${mobileMedia} {
        flex-direction: column;
        border: 1px solid rgba(45, 28, 28, 0.1);
        border-radius: var(--radius-xl) var(--radius-xl) 0 0;
        overflow: hidden;
    }
`;

export const timeLabel = styled(shellTimeLabel)`
    ${mobileMedia} {
        width: 100%;
        gap: 10px;
        background: rgba(0, 0, 0, 0.05);
        border-bottom: 1px solid rgba(0, 0, 0, 0.10);
        min-height: 50px;
    }
`;

export const lecturesArea = styled.div`
    flex: 1;
    ${dFlex};
    align-items: stretch;
    padding: 10px;
    gap: 10px;
    overflow-x: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
    &::-webkit-scrollbar { height: 2px; }
    ${mobileMedia} {
        flex-direction: column;
        overflow-x: unset;
        padding: 16px 16px 0;
        gap: 10px;
    }
`;

export const addLecture = styled.div<{expanded?: boolean}>`
    width: 259px;
    flex-shrink: 0;
    height: ${p => p.expanded ? '191px' : '72px'};
    border-radius: var(--radius-xs);
    border: 2px dashed var(--TA-color-brand-main);
    ${dFlexCenter};
    cursor: pointer;
    order: 1;
    ${mobileMedia} {
        width: auto;
        height: auto;
        padding: var(--space-lg) 0;
        justify-content: center;
        align-items: center;
        align-self: stretch;
        margin-inline: -16px;
        border: none;
        border-top: 1px solid var(--TA-color-border-subtle);
        background: transparent;
        border-radius: 0;
        pointer-events: none;
    }
`;

export const addButton = styled.div`
    width: 32px;
    height: 32px;
    border-radius: var(--radius-full);
    background: var(--TA-color-brand-main);
    ${dFlexCenter};
    pointer-events: none;
    ${mobileMedia} {
        display: none;
    }
`;

export const mobileBtnWrapper = styled.div`
    display: none;
    ${mobileMedia} {
        display: block;
        pointer-events: auto;
    }
`;
